














































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../lib/abpbase";
import Membership from "../../store/entities/membership";
import Editor from "@tinymce/tinymce-vue";
import TinymceInit from "../../lib/TinymceInit";
import MultiPicture from "../../components/multi-picture.vue";
import RegionSelect from "../../components/region-select.vue";
import { Survey } from "../../lib/tinymce-initial-value";
import appconst from "../../lib/appconst";
import Ajax from "@/lib/ajax";
TinymceInit.height = 300;

@Component({
  components: { Editor, RegionSelect, MultiPicture },
})
export default class CreateMembership extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;

  membership: Membership = new Membership();
  showOnHome: boolean = false;
  tinymceInit = TinymceInit;
  uploadUrl: string = appconst.remoteServiceBaseUrl + "Picture/UploadPicture";
  survey = Survey;
  courtList = [];

  get extData() {
    return {
      membershipId: this.membership.id,
    };
  }

  save() {
    (this.$refs.membershipForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "membership/create",
          data: {
            membership: this.membership,
            images: this.membership.membershipImages,
          },
        });
        (this.$refs.membershipForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
        this.$Message.success({
          content: "添加成功",
        });
      }
    });
  }
  cancel() {
    (this.$refs.membershipForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  async created() {
    let reponse = await Ajax.get("/api/services/app/Court/GetAllCourtNames");
    this.courtList = reponse.data.result;
    console.log(this.courtList, "this.court");
  }
  validateCourtId(rule, value, callback) {
    if (!value) {
      return callback(new Error("请选择球场"));
    } else {
      callback();
    }
  }

  membershipRule = {
    name: [
      {
        required: true,
        message: "请输入名称",
        trigger: "blur",
      },
    ],
    price: [
      {
        required: true,
        message: "请输入球会牌价",
        trigger: "blur",
        type: "number",
      },
    ],
    transferFee: [
      {
        required: true,
        message: "请输入转让费",
        trigger: "blur",
        // type: "number",
      },
    ],
    monthlyFee: [
      {
        required: true,
        message: "请输入月费",
        trigger: "blur",
        type: "number",
      },
    ],
    flow: [
      {
        required: true,
        message: "请输入使用流程",
        trigger: "blur",
      },
    ],
    position: [
      {
        required: true,
        message: "请输入位置",
        trigger: "blur",
      },
    ],
    description: [
      {
        required: true,
        message: "请输入球会简介",
        trigger: "blur",
      },
    ],
    courtId: [
      { required: true, validator: this.validateCourtId, trigger: "blur" },
    ],
  };
}
